import React from 'react';
import { Box, List, ListItem, ListItemText, ListItemSecondaryAction, IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useTags } from '../../../../utils/context/tags/TagsContext';

const TagList = () => {
  
  const {tags, removeTag, fetchTags } = useTags();

  const handleRefresh = async () => {
    fetchTags();
  };

  const handleDelete = (tag) => {
    removeTag(tag);
  };


  return (
    <Box>
      {/* Refresh Button */}

      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton aria-label="refresh" onClick={handleRefresh}>
          <RefreshIcon />
        </IconButton>
      </Box>

      <List>
        {tags.map((tag) => (
          <ListItem key={tag.id}>
            <ListItemText primary={tag.tagName} />

            <ListItemSecondaryAction>
              <IconButton edge="end" aria-label="delete" onClick={() => handleDelete(tag)}>
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default TagList;
